import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storageSubject = new Subject<string>();

  watchStorage(): Observable<string> {
    return this.storageSubject.asObservable();
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
    this.storageSubject.next(value);
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }
}
